<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <div class="row m-0 col-md-12 p-0">
    <div class="col-md-2">
      <span class="button-wrap">
        <label class="mt-3 btn font-size-12 button-btn" for="ImportLoanData1"
          >Import Loan Data</label
        >
        <input
          #fileInput
          type="file"
          id="ImportLoanData1"
          (change)="GetImportLoanData($event)"
          style="display: none"
          accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
      </span>
    </div>

    <div class="col-md-2 text-right mt-3">
      <button
        type="button"
        (click)="onImportLoanCustomerData()"
        class="btn font-size-12 button-btn"
        
      >
        Import Customer Data
      </button>
    </div>

    <div class="col-md-2 text-right mt-3">
      <button
        type="button"
        (click)="onImportDvData()"
        class="btn font-size-12 button-btn"
        
      >
        Import Loan DV Data
      </button>
    </div>

    <div class="col-md-3 text-right mt-3">
      <button
        type="button"
        (click)="onImportPaymentDvData()"
        class="btn font-size-12 button-btn"
        
      >
        Import Loan DV Payment Data
      </button>
    </div>


  </div>
</div>

<div class="mt-3" *ngIf="DataSource">
  <div class="">
    <div class="table-responsive">
      <mat-table
        [dataSource]="DataSource"
        matSort
        matTableExporter
        #exporter="matTableExporter"
        style="max-width: 100%; overflow: auto; height: 60vh"
      >
        <ng-container matColumnDef="Id">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >#</mat-header-cell
          >
          <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw50">
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
            style="max-width: 3.125rem"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="LoanAcNo">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Loan No</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.LoanAcNo }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="LoanAmount">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Loan Amount</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.LoanAmount }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="LoanTenure">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Loan Tenure</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.LoanTenure }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="LoanEMIAmount">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Loan EMI Amount</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.LoanEMIAmount }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="EMIType">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >EMI Type</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.EMIType }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="LoanPurpose">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Loan Purpose</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.LoanPurpose }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="FirstEMIDate_YYYY_MM_DD">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >First EMI Date</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.FirstEMIDate_YYYY_MM_DD }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Loan_Date_YYYY_MM_DD">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Loan Date</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Loan_Date_YYYY_MM_DD }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Case_IRR">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            Case IRR
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Case_IRR | number : "1.2-2" }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Disbursement_IRR">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            Disbursement IRR
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Disbursement_IRR | number : "1.2-2" }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Effectice_IRR">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            Effective IRR
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Effectice_IRR }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="ROI">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            ROI
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.ROI }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Interest_Amt">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Interest Amt</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Interest_Amt }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="View">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Action</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            <button
              type="button"
              *ngIf="row.LoanExist == 0"
              (click)="OnLoanConvert(row)"
              class="font-size-12 button-btn"
              mat-raised-button
            >
              Convert
            </button>
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="grid-header"
          ></mat-footer-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <mat-footer-row
          class="sticky-footer fontcolor"
          *matFooterRowDef="displayedColumns; sticky: true"
          style="background: var(--theme-primary)"
        ></mat-footer-row>
      </mat-table>
      <div class="row m-0 align-items-center">
        <!-- <div class="col-md-4">
          <button
            class="mt-3 btn font-size-12 button-btn"
            (click)="exportTable()"
          >
            <i
              class="fa fa-file-export mr-1"
              style="font-size: medium; cursor: pointer"
            ></i>
            Export
          </button>
        </div> -->
        <div class="col-md-8">
          <mat-paginator
            #paginatorRef
            [pageSizeOptions]="[20, 50]"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
